import App from "./App.svelte";

new App({
  target: document.querySelector(".todoapp"),
});
